import { render, staticRenderFns } from "./global-admin-dashboard-view.vue?vue&type=template&id=53ffce22&scoped=true"
import script from "./global-admin-dashboard-view.vue?vue&type=script&lang=js"
export * from "./global-admin-dashboard-view.vue?vue&type=script&lang=js"
import style0 from "./global-admin-dashboard-view.vue?vue&type=style&index=0&id=53ffce22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ffce22",
  null
  
)

export default component.exports